exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cardList__CompanyUserSelectionComponent-module___KuwQU {\n  gap: 8px;\n  align-items: flex-end;\n  margin-top: 8px;\n  border: 1px solid #b3b3b3;\n  border-radius: 0.375rem;\n  padding: 6px 12px;\n}\n\n.selected__CompanyUserSelectionComponent-module___1_tNf {\n  border: 1px solid #86b7fe;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n", ""]);

// Exports
exports.locals = {
	"cardList": "cardList__CompanyUserSelectionComponent-module___KuwQU",
	"selected": "selected__CompanyUserSelectionComponent-module___1_tNf"
};